import React from 'react';
import {Link} from 'react-scroll';

const ScrollLink = ({children, ...props}) => {
  return (
    <Link {...props}
          href="#"
          duration={500}
          spy
          smooth>
      { children }
    </Link>
  )
}

export default ScrollLink;
